export default "__VITE_ASSET__CxRIKYA4__"